export const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    fill="none"
    viewBox="0 0 56 56"
  >
    <rect width="55" height="55" x="0.5" y="0.5" fill="#F3F4F6" rx="7.5"></rect>
    <rect
      width="55"
      height="55"
      x="0.5"
      y="0.5"
      stroke="#E5E7EB"
      rx="7.5"
    ></rect>
    <mask
      id="mask0_3857_34148"
      width="24"
      height="24"
      x="16"
      y="16"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path fill="#D9D9D9" d="M16 16h24v24H16z"></path>
    </mask>
    <g mask="url(#mask0_3857_34148)">
      <path
        fill="#6B7280"
        d="M28 35a.97.97 0 0 1-.712-.288A.97.97 0 0 1 27 34v-5h-5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 21 28q0-.424.288-.712A.97.97 0 0 1 22 27h5v-5q0-.424.288-.712A.97.97 0 0 1 28 21q.424 0 .712.288.288.287.288.712v5h5q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 34 29h-5v5q0 .424-.288.712A.97.97 0 0 1 28 35"
      ></path>
    </g>
  </svg>
);
